export default "__VITE_ASSET__bfa9427b__"